module.exports = __webpack_public_path__ + "static/img/platphom6.37f5d71e.png";